import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/Button';
import { Input } from '../components/Input';
export function Register() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [validations, setValidations] = useState({
    length: false,
    lowercase: false,
    uppercase: false,
    special: false,
    match: false
  });
  const {
    register
  } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    setValidations({
      length: password.length >= 8,
      lowercase: /[a-z]/.test(password),
      uppercase: /[A-Z]/.test(password),
      special: /[!@#$%^&*(),.?":{}|<>]/.test(password),
      match: password === confirmPassword && password.length > 0
    });
  }, [password, confirmPassword]);
  const isFormValid = Object.values(validations).every(Boolean) && name.trim() !== '' && email.trim() !== '';
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (!isFormValid) {
      setError('Mohon lengkapi semua persyaratan formulir');
      return;
    }
    setIsLoading(true);

    // 🔥 REGISTER KE SUPABASE
    const {
      error
    } = await register(email, password);
    if (error) {
      // handle error dari Supabase
      if (error.message.includes('User already registered')) {
        setError('Email sudah terdaftar');
      } else {
        setError(error.message);
      }
      setIsLoading(false);
      return;
    }

    // ✅ sukses
    alert('Berhasil daftar, silakan login');
    navigate('/login');
  };
  const ValidationItem = ({
    isValid,
    text
  }: {
    isValid: boolean;
    text: string;
  }) => <div className="flex items-center gap-2 text-sm" data-id="element-586">
      {isValid ? <Check size={16} className="text-green-500" data-id="element-587" /> : <X size={16} className="text-gray-300" data-id="element-588" />}
      <span className={isValid ? 'text-gray-700' : 'text-gray-400'} data-id="element-589">
        {text}
      </span>
    </div>;
  return <div className="min-h-screen flex items-center justify-center bg-pastel-grey-light px-4 py-12 sm:px-6 lg:px-8" data-id="element-590">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} className="max-w-md w-full space-y-8 bg-white p-8 sm:p-10 rounded-3xl shadow-apple" data-id="element-591">
        <div className="text-center" data-id="element-592">
          <Link to="/" className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-pastel-blue mb-6" data-id="element-593">
            <span className="text-2xl font-bold text-dark" data-id="element-594">BK</span>
          </Link>

          <h2 className="text-3xl font-bold text-dark tracking-tight" data-id="element-595">
            Buat Akun
          </h2>

          <p className="mt-2 text-sm text-gray-500" data-id="element-596">
            Daftar untuk mengakses semua layanan BK
          </p>
        </div>

        <form className="mt-8 space-y-6" onSubmit={handleSubmit} data-id="element-597">
          <div className="space-y-4" data-id="element-598">
            <Input label="Nama Lengkap" type="text" placeholder="John Doe" value={name} onChange={e => setName(e.target.value)} required data-id="element-599" />

            <Input label="Email" type="email" placeholder="nama@email.com" value={email} onChange={e => setEmail(e.target.value)} required data-id="element-600" />

            <Input label="Kata Sandi" type="password" placeholder="••••••••" value={password} onChange={e => setPassword(e.target.value)} required data-id="element-601" />

            {/* VALIDATION */}
            <div className="bg-pastel-grey-light p-4 rounded-xl space-y-2" data-id="element-602">
              <p className="text-xs font-semibold text-dark mb-2" data-id="element-603">
                Persyaratan Kata Sandi:
              </p>
              <ValidationItem isValid={validations.length} text="Minimal 8 karakter" data-id="element-604" />
              <ValidationItem isValid={validations.lowercase} text="Mengandung huruf kecil" data-id="element-605" />
              <ValidationItem isValid={validations.uppercase} text="Mengandung huruf besar" data-id="element-606" />
              <ValidationItem isValid={validations.special} text="Mengandung karakter unik (!@#$%)" data-id="element-607" />
            </div>

            <Input label="Konfirmasi Kata Sandi" type="password" placeholder="••••••••" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} required data-id="element-608" />

            {confirmPassword.length > 0 && <ValidationItem isValid={validations.match} text="Kata sandi cocok" data-id="element-609" />}
          </div>

          {error && <motion.p initial={{
          opacity: 0,
          height: 0
        }} animate={{
          opacity: 1,
          height: 'auto'
        }} className="text-sm text-red-500 text-center" data-id="element-610">
              {error}
            </motion.p>}

          <Button type="submit" fullWidth isLoading={isLoading} size="lg" disabled={!isFormValid} data-id="element-611">
            Daftar
          </Button>
        </form>

        <div className="text-center mt-6" data-id="element-612">
          <p className="text-sm text-gray-600" data-id="element-613">
            Sudah punya akun?{' '}
            <Link to="/login" className="font-medium text-dark hover:underline" data-id="element-614">
              Masuk di sini
            </Link>
          </p>
        </div>
      </motion.div>
    </div>;
}